import { getCanonicalDeviceStatus, normalizeCanonicalStatus } from './deviceStatus';

export const isValidGPS = (lat, lng) => {
  if (typeof lat !== 'number' || typeof lng !== 'number') return false;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return false;
  if (lat === 0 && lng === 0) return false;
  return true;
};

export const getCanonicalVehicleStatus = (device = {}, socketData = {}) =>
  getCanonicalDeviceStatus(device, socketData);

export const getDeviceStatus = getCanonicalVehicleStatus;
export const resolveStatus = getCanonicalVehicleStatus;

export const getResolvedLiveSnapshot = (device = {}, socketData = {}) => {
  const source = {
    ...(device?.liveData || {}),
    ...(device?.deviceLive || {}),
    ...(device?.liveSnapshot || {}),
    ...socketData,
  };

  const latitude = Number(source?.latitude ?? source?.lat);
  const longitude = Number(source?.longitude ?? source?.lng);

  return {
    timestampMs: Date.parse(source?.timestamp || source?.serverTime || source?.lastUpdate || '') || 0,
    latitude: Number.isFinite(latitude) ? latitude : null,
    longitude: Number.isFinite(longitude) ? longitude : null,
    speed: Number(source?.speed ?? source?.currentSpeed ?? 0) || 0,
    accStatus: source?.accStatus ?? source?.ignition ?? null,
    heading: Number(source?.heading ?? source?.course ?? source?.bearing ?? 0) || 0,
    vehicleStatusRaw: getCanonicalVehicleStatus(device, socketData),
    movementStateRaw: source?.movementState ?? source?.movement_state ?? null,
    hasGps: isValidGPS(latitude, longitude),
  };
};

export const getStatusConfig = (status) => {
  const configs = {
    running: { label: 'Running', dot: '#10b981', bg: '#d1fae5', text: '#065f46', icon: '🟢' },
    idle: { label: 'Idle', dot: '#fef3c7', bg: '#fef3c7', text: '#92400e', icon: '🟡' },
    stopped: { label: 'Stopped', dot: '#ef4444', bg: '#fee2e2', text: '#991b1b', icon: '🔴' },
    inactive: { label: 'Not reporting', dot: '#0ea5e9', bg: '#e0f2fe', text: '#075985', icon: '🔵' },
    expired: { label: 'Expired', dot: '#7c3aed', bg: '#ede9fe', text: '#5b21b6', icon: '🟣' },
    no_data: { label: 'No Data', dot: '#6b7280', bg: '#f3f4f6', text: '#374151', icon: '⚫' },
  };

  return configs[normalizeCanonicalStatus(status) || 'no_data'] || configs.no_data;
};

export const isDeviceOnline = (device, socketData = {}) =>
  ['running', 'idle', 'stopped'].includes(getCanonicalVehicleStatus(device, socketData));

export const isDeviceInactive = (device, socketData = {}) =>
  getCanonicalVehicleStatus(device, socketData) === 'inactive';

export const isRunning = (device, socketData = {}) => getCanonicalVehicleStatus(device, socketData) === 'running';
export const isIdle = (device, socketData = {}) => getCanonicalVehicleStatus(device, socketData) === 'idle';
export const isStopped = (device, socketData = {}) => getCanonicalVehicleStatus(device, socketData) === 'stopped';
export const isOffline = (device, socketData = {}) => getCanonicalVehicleStatus(device, socketData) === 'inactive';
